class SitewideBanner {
    constructor() {

    }

    init(helpers) {
        const self = this;

        let closeButton,
            heading,
            sitewideBanner = document.querySelector('.sitewide-banner'),
            status;

        if (!sitewideBanner) return;

        status = sessionStorage.getItem('sitewide_banner') ? sessionStorage.getItem('sitewide_banner') : null;

        if (status === '0') {
            return document.body.classList.remove('has-sitewide-banner');
        }

        if (!status) {
            status = '1';

            sessionStorage.setItem('sitewide_banner', '1');
        }

        heading = sitewideBanner.querySelector('.heading');

        closeButton = helpers.createElementFromString(`
            <button
                type="button"
                class="close-button"
                aria-controls="${sitewideBanner.id}"
                aria-describedby="${heading.id}"
            >
                <span class="text">${i18n['sitewide_banner']['close']}</span>
            </button>
        `);

        sitewideBanner.appendChild(closeButton);

        closeButton = sitewideBanner.querySelector('.close-button');

        closeButton.addEventListener('click', function(e) {
            sessionStorage.setItem('sitewide_banner', '0');
            sitewideBanner.hidden = true;

            document.body.classList.remove('has-sitewide-banner');
            
            wp.a11y.speak(i18n['sitewide_banner']['closed']);
        });

        sitewideBanner.hidden = false;

    }
}

export default SitewideBanner;

